import { useState, useEffect, useCallback } from "react";

export function useNotificationPermission() {
  const [permission, setPermission] = useState<NotificationPermission | "unsupported">(
    typeof Notification !== "undefined" ? Notification.permission : "unsupported"
  );

  useEffect(() => {
    if (typeof Notification === "undefined") {
      setPermission("unsupported");
    } else {
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = useCallback(async () => {
    if (typeof Notification === "undefined") {
      return "unsupported" as const;
    }
    try {
      const result = await Notification.requestPermission();
      setPermission(result);
      return result;
    } catch {
      return "denied" as const;
    }
  }, []);

  const sendTestNotification = useCallback(() => {
    if (permission === "granted") {
      new Notification("St. David College", {
        body: "Notifications are enabled! You'll receive important updates here.",
        icon: "/icons/icon-192x192.png",
      });
    }
  }, [permission]);

  return { permission, requestPermission, sendTestNotification };
}
